import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

import Users from '../pages/Users'
import EditUser from '../pages/EditUser'
import Login from '../pages/Login'
import SignUp from '../pages/SignUp'
import NotFound from '../pages/NotFound'
import Events from '../pages/Events'
import EditEvent from '../pages/EditEvent'
import Projects from '../pages/Projects'
import EditProject from '../pages/EditProject'

import AdminWorkHoursReport from '../pages/admin/WorkHoursReport'
import AdminEditWorkHoursReport from '../pages/admin/EditWorkHoursReport'
import AdminVacationDaysReport from '../pages/admin/VacationDaysReport'
import AdminEditVacationDaysReport from '../pages/admin/EditVacationDaysReport'
import AdminVolunteerWorkHoursReport from '../pages/admin/VolunteerWorkHoursReport'
import AdminEditVolunteerWorkHoursReport from '../pages/admin/EditVolunteerWorkHoursReport'

import WorkHoursReport from '../pages/user/WorkHoursReport'
import EditWorkHoursReport from '../pages/user/EditWorkHoursReport'
import VacationDaysReport from '../pages/user/VacationDaysReport'
import VolunteerWorkHoursReport from '../pages/user/VolunteerWorkHoursReport'
import EditVolunteerWorkHoursReport from '../pages/user/EditVolunteerWorkHoursReport'
import EventEvaluation from "../pages/EventEvaluation";
import EditEventEvaluation from "../pages/EditEventEvaluation";
import EventEvaluationVote from "../pages/EventEvaluationVote";
import List from "../pages/List";
import Orchids from "../pages/Orchids";
import UPNqr from "../pages/UPNqr";

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/uporabniki',
      name: 'Users',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/uporabnik/:id?',
      name: 'EditUser',
      component: EditUser,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dogodki',
      name: 'Events',
      component: Events,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dogodek/:id?',
      name: 'EditEvent',
      component: EditEvent,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/evalvacija-dogodkov',
      name: 'EventEvaluation',
      component: EventEvaluation,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/evalvacija-dogodka/:id?',
      name: 'EditEventEvaluation',
      component: EditEventEvaluation,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/evalvacija-dogodkov-glasovanje/:id?',
      name: 'EventEvaluationVote',
      component: EventEvaluationVote,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/projekti',
      name: 'Projects',
      component: Projects,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/projekt/:id?',
      name: 'EditProject',
      component: EditProject,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/evidenca-dela',
    //   name: 'WorkHoursReport',
    //   component: WorkHoursReport,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/delo/:id?',
    //   name: 'EditWorkHoursReport',
    //   component: EditWorkHoursReport,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },

    // ADMIN
    {
      path: '/admin/evidenca-dela',
      name: 'AdminWorkHoursReport',
      component: AdminWorkHoursReport,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/delo/:id?:readonly?:date?',
      name: 'AdminEditWorkHoursReport',
      component: AdminEditWorkHoursReport,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/admin/evidenca-dopusta',
      name: 'AdminVacationDaysReport',
      component: AdminVacationDaysReport,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/dopust/:id?',
      name: 'AdminEditVacationDaysReport',
      component: AdminEditVacationDaysReport,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/admin/evidenca-prostovoljskega-dela',
      name: 'AdminVolunteerWorkHoursReport',
      component: AdminVolunteerWorkHoursReport,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/prostovoljsko-delo/:id?',
      name: 'AdminEditVolunteerWorkHoursReport',
      component: AdminEditVolunteerWorkHoursReport,
      meta: {
        requiresAuth: true
      }
    },

    // USER
    {
      path: '/evidenca-dela',
      name: 'WorkHoursReport',
      component: WorkHoursReport,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/delo/:id?:readonly?:date?',
      name: 'EditWorkHoursReport',
      component: EditWorkHoursReport,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/evidenca-dopusta',
      name: 'VacationDaysReport',
      component: VacationDaysReport,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/evidenca-prostovoljskega-dela',
      name: 'VolunteerWorkHoursReport',
      component: VolunteerWorkHoursReport,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/prostovoljsko-delo/:id?',
      name: 'EditVolunteerWorkHoursReport',
      component: EditVolunteerWorkHoursReport,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/orchids',
      name: 'Orchids',
      component: Orchids,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/list/:id?',
      name: 'List',
      component: List,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/upn-qr',
      name: 'UPNqr',
      component: UPNqr,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  // let userTokeName =  sessionStorage.getItem("DP_user") ? JSON.parse(sessionStorage.getItem("DP_user")).userTokeName : null;
  //
  // let currentUser =  userTokeName ? sessionStorage.getItem(userTokeName) : null;
  // let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  //
  // if (requiresAuth && !currentUser) {
  //   next('login')
  // } else if (!requiresAuth && currentUser) {
  //   next('uporabniki')
  // } else {
  //   next()
  // }

  let userTokeName =  sessionStorage.getItem("DP_user") ? JSON.parse(sessionStorage.getItem("DP_user")).userTokeName : null;

  let currentUser =  userTokeName ? JSON.parse(sessionStorage.getItem("DP_user")).userTokeName : null;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  let isAdmin = sessionStorage.getItem("DP_user") ? JSON.parse(sessionStorage.getItem("DP_user")).administrator : false;

  if (requiresAuth && !currentUser) {
    next('/login')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js